<template>
  <div class="report-config-warp">
    <h2 class="edm-form-title">
      <span class="edm-form-title--text">报表详情</span>
      <back @back="closeModel"></back>
    </h2>
    <div>
      <el-form
        ref="formEl"
        :model="formData"
        :disabled="true"
        class="demo-formData clearfix"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="报表编码">
              <el-input
                v-model="formData.reportCode"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报表名称">
              <el-input
                v-model="formData.reportName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据源">
              <el-select
                v-model="formData.datasourceId"
                class="w100"
              >
                <el-option
                  v-for="option in dataSourceList"
                  :key="option.id"
                  :label="option.datasourceName"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- SQL表达式 -->
          <el-col :span="20">
            <el-form-item label="SQL表达式">
              <el-input
                v-model="formData.originalSql"
                type="textarea"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 描述 -->
          <el-col :span="20">
            <el-form-item label="描述">
              <el-input
                v-model="formData.description"
                type="textarea"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="tab-info">
      <el-tabs v-model="activeName" class="custom-tabs">
        <el-tab-pane label="搜索列" name="search">
          <search-config-list ref="searchConfigListEl" :disabled="true"/>
        </el-tab-pane>
        <el-tab-pane label="表格列" name="table">
          <report-table-list ref="reportTableListEl" :disabled="true"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Back from "@/components/common/Back";
import SearchConfigList from "./inner-components/search-config-list.vue";
import ReportTableList from "./inner-components/report-table-list.vue";
import excelApi from "@/api/excel/excel";
import reportConfigApi from "@/api/report-config/index";
export default {
  name: "ReportConfigEdit",
  components: {
    Back,
    SearchConfigList,
    ReportTableList
  },
  data() {
    return {
      activeName: "search",
      formData: {
        reportCode: "",
        reportName: "",
        originalSql: "",
        description: "",
        datasourceId: ""
      },
      dataSourceList: []
    };
  },
  created() {
    this.getDatasourceList();
    this.getReportDetails();
  },
  methods: {
    // 获取数据源
    getDatasourceList() {
      excelApi.getDatasource().then(res => {
        this.dataSourceList = res.data;
      });
    },
    getReportDetails() {
      const params = {
        id: this.$route.query.id
      };
      reportConfigApi.getReportDetails(params).then(res => {
        if (res.success && res.data) {
          this.$set(this.formData, "reportCode", res.data.reportCode);
          this.$set(this.formData, "reportName", res.data.reportName);
          this.$set(this.formData, "originalSql", res.data.originalSql);
          this.$set(this.formData, "description", res.data.description);
          this.$set(this.formData, "datasourceId", res.data.datasourceId);
          this.$refs.searchConfigListEl.setData(res.data);
          this.$refs.reportTableListEl.setData(res.data);
        }
      });
    },
    closeModel() {
      this.$router.push({
        path: "/report-config/report-config-list"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.report-config-warp{
    padding: 24px;
    height: 100%;
    overflow-y: auto;
}
.edm-form-title {
  display: flex;
  padding-bottom: 16px;
  font-size: 18px;
  line-height: 18px;
  justify-content: space-between;

  .edm-form-title--text {
    font-weight: 500;

    &::before {
      display: inline-block;
      width: 3px;
      height: 18px;
      margin-right: 8px;
      vertical-align: middle;
      background: #00b259;
      content: '';
      opacity: 1;
    }
  }
}
</style>
